export const IN_LIST_MODE = {
    IN_LIST_COLUMN: 'in-list-column',
    IN_LIST_QUICK_NOTES: 'in-list-quick-notes',
    IN_LIST_UNSORTED_NOTES: 'in-list-unsorted-notes',
    IN_LIST_DOCUMENT_MODE: 'in-list-document-mode',
    IN_LIST_TRASH: 'in-list-trash',
};
